<div id="main-wrapper" style="height: 100%;">

  <app-sidebar></app-sidebar>

  <div id="psl-w" class="page-wrapper eda-page-class" [style.backgroundColor]="backgroundColor" [class.noSidebar]="panelMode">

    <div class="container-fluid" style="height: 100%;">

      <router-outlet></router-outlet>

    </div>

  </div>
  
</div>

<p-confirmDialog  [style]="{width: '30vw'}" header="Confirmation" icon="pi pi-exclamation-triangle" appendTo="body"></p-confirmDialog>